import { Frame } from '@hakimo-ui/hakimo/types';
import { FramePlayer } from '@hakimo-ui/hakimo/ui-elements';
import { PlayIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

interface Props {
  frames: Frame[];
  timeZone: string;
  showMatchedFaces: boolean;
  disableDownload?: boolean;
}

export function AlarmFrames(props: Props) {
  const { frames, timeZone, showMatchedFaces, disableDownload } = props;
  const [frameIndex, setFrameIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  return (
    <div
      className="relative aspect-video w-full"
      onClick={() => setPaused((p) => !p)}
      onContextMenu={disableDownload ? (e) => e.preventDefault() : undefined}
    >
      <FramePlayer
        key={paused ? 'paused' : 'playing'}
        frames={frames}
        currentFrameIndex={frameIndex}
        timeZone={timeZone}
        onFrameChange={setFrameIndex}
        elaborateFrames
        paused={paused}
        showMatchedFaces={showMatchedFaces}
      />
      {paused && (
        <div className="pointer-events-none absolute inset-0 z-10 grid place-items-center">
          <PlayIcon className="text-ondark-text-1 h-10 w-10 drop-shadow-lg" />
        </div>
      )}
    </div>
  );
}

export default AlarmFrames;
